import { initialState } from '@/store/user/moduleUserState';

const mutations = {
  UPDATE_TOKEN( state ) {
    state.token = localStorage.token;
  },
  SET_UNAUTH( state ) {
    console.log(initialState);
    Object.assign(state, { ...initialState });
    state.auth = false;
  },
  SET_USER_INFO( state, payload ) {
    Object.assign(state, payload);
    state.auth = true;
  },
  SET_ACCOUNT_NUMBER( state, payload ) {
    state.account_number = payload;
  },
  SET_APARTS( state, payload ) {
    state.aparts = payload;
  },
  SET_KVIT_INFO( state, payload ) {
    state.kvit = payload;
  },
  SET_PAYMENTS( state, payload ) {
    state.payments = payload;
  },
  SET_DEVICE_TYPES( state, payload ) {
    state.device_types = payload;
  },
  SET_PAYMENTS_TYPES( state, payload ) {
    state.paymentTypes = payload;
  },
  SET_DEVICES_SETTING( state, payload ) {
    state.devicesSettings = payload;
  },
  SET_SEND_CHARGE_EMAIL( state, payload ) {
    let apartIndex = state.aparts.findIndex(apart => apart.account_number === +state.account_number);
    state.aparts[apartIndex].send_charge_email = payload;
  },
  SET_RASH( state, payload ) {
    state.rash = payload;
  },
  UPDATE_USER_AVATAR( state, payload ) {
    state.avatar = payload;
  },
  SET_HOUSES( state, { list, groups } ) {
    state.houses = list;
    state.housesGroups = groups;
  },
  SET_SELECTED_HOUSE( state, payload ) {
    state.selectedHouse = payload;
  },
  SET_DATE( state, payload ) {
    state.selectedDate = payload;
  },
  SET_APARTMENTS_TYPES( state, payload ) {
    state.apartmentsTypes = payload;
  },
  SET_PERMISSIONS( state, payload ) {
    state.permissions = payload;
  },
};

export default mutations;
